var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{staticStyle:{"height":"200px"},attrs:{"visible":_vm.isShowImport,"title":"上传进度"},on:{"update:visible":function($event){_vm.isShowImport=$event},"close":function($event){return _vm.doClose()}}},[_c('el-progress',{attrs:{"percentage":_vm.process}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }